import { BigNumberish } from 'ethers'
import { Farm } from '@/constants/contract/contractTypes'

export interface PoolLengthCallParams {
  contract: Farm
}

export const poolLengthCall = async ({ contract }: PoolLengthCallParams) => {
  return contract.poolLength()
}

export interface PoolsCallParams {
  contract: Farm
  poolId: BigNumberish
}

export const poolsCall = async ({ contract, poolId }: PoolsCallParams) => {
  return contract.pools(poolId)
}

export interface UsersCallParams {
  contract: Farm
  poolId: BigNumberish
  accountAddress: string
}

export const usersCall = async ({ contract, poolId, accountAddress }: UsersCallParams) => {
  return contract.users(poolId, accountAddress)
}

export interface StakeCallParams {
  contract: Farm
  poolId: BigNumberish
  amount: BigNumberish
}

export const stakeCall = async ({ contract, poolId, amount }: StakeCallParams) => {
  return (await contract.stake(poolId, amount)).wait()
}

export interface ClaimCallParams {
  contract: Farm
  poolId: BigNumberish
}

export const claimCall = async ({ contract, poolId }: ClaimCallParams) => {
  return (await contract.claim(poolId)).wait()
}

export interface UnstakeCallParams {
  contract: Farm
  poolId: BigNumberish
  amount: BigNumberish
}

export const unstakeCall = async ({ contract, poolId, amount }: UnstakeCallParams) => {
  return (await contract.unstake(poolId, amount)).wait()
}

export interface EarnedCallParams {
  contract: Farm
  poolId: BigNumberish
  accountAddress: string
}

export const earnedCall = async ({ contract, poolId, accountAddress }: EarnedCallParams) => {
  return contract.earned(poolId, accountAddress)
}
